module.exports = __webpack_public_path__ + "img/wy-active.054013e4.png";